import React from 'react';
import {observer, inject} from 'mobx-react';
import {Dropdown} from '@enos/dpl';
import localeText from '@locale';
import CompanySwitchList, {showCompanySwitchModal} from '~/components/CompanySwitchList';
import {USER_PERMISSION_TYPE} from '~/utils/constants';
import {getPublicKey} from '~/utils/encrypt';
import ChangeCipher, {showChangePasswordModal} from '~/components/ChangeCipher';
import './index.less';
import LanguageSwitch, {showLanguageSwitcherModal} from '~/components/LanguageSwitchList';
import ChangeTheme, {showChangeThemeModal} from '../ChangeTheme';
import ProfileExpand from './ProfileExpand';
import store from '../store';

@inject((stores, props) => {
  const {sessionStore, securityStore} = stores;
  return {
    ...props,
    sessionStore,
    securityStore
  };
})
@observer
class Profile extends React.Component {
  handleDropdownClick = (e) => {
    const classNotDropUp = ['profile', 'info', 'info-items', 'name', 'email', 'account', 'info-container info-all', 'info-container', 'profile-info', 'info-title', 'infos', 'show-all', 'dplicon_direction_down', 'dplicon_direction_up', 'profile-expand-content',
      'profile-expand', 'profile-expand-items', 'expand-item', 'dpl20_user', 'fix-icon', 'dpl20_caret_up_s', 'dpl20_caret_down_s', 'active image', 'image', 'active-admin', 'admin', 'ant-row', 'operation-list', 'admin-info', 'admin-title', 'admin-info-detail', 'dplicon_wrong_s', 'admin-account', 'admin-email', 'admin-info-title', 'ant-tooltip-inner'];
    if (classNotDropUp.includes(e.target.className)) {
      e.stopPropagation();
    }
  };

  toggleInfo = () => {
    store.setShowAllProfileInfo(!store.showAllProfileInfo);
    store.setShowAdminInfo(false);
  };

  getInfoTitle = (title) => {
    if (title === 'nickName') {
      return localeText('USER.COLH_NICKNAME');
    }
    if (title === 'name') {
      return localeText('USER.COLH_ACCT_NO');
    }
    if (title === 'email') {
      return localeText('USER.COLH_EMAIL');
    }
    if (title === 'phone') {
      return localeText('USER.COLH_PHONE');
    }
    return false;
  };

  getInfo = (title) => {
    const {currentUserInfo} = this.props.sessionStore;
    if (title === 'phone') {
      const phone = currentUserInfo?.phoneArea && currentUserInfo?.phone ? `${currentUserInfo?.phoneArea} ${currentUserInfo?.phone}` : currentUserInfo?.phone || '-';
      return <span className='infos' title={phone}>{phone}</span>;
    }
    return <span className='infos' title={currentUserInfo?.[title] || '-'}>{currentUserInfo?.[title] || '-'}</span>;
  };

  getProfile = ({currentUser: user, userPermissionType, profileInfo, currentUserInfo}, fromPortal) => (
    <div>
      <div className='triangle' />
      <div className='profile' onClick={this.handleDropdownClick}>
        {
          !profileInfo
            ? (
              <div className='info'>
                <div className='info-items'>
                  <div className='name' title={user.name}>{user.name}</div>
                  <div className='email' title={user.email}>{user.email}</div>
                </div>
              </div>
            )
            : (
              <div className='info'>
                <div className='info-items'>
                  <div className='account' title={currentUserInfo?.[profileInfo[0]]}>{currentUserInfo?.[profileInfo[0]]}</div>
                  <div
                    className={store.showAllProfileInfo ? 'info-container info-all' : 'info-container'}
                  >
                    {profileInfo[1] && this.getInfoTitle(profileInfo[1]) && (
                      <div className='profile-info'>
                        <span className='info-title'>{this.getInfoTitle(profileInfo[1])}</span>
                        {this.getInfo(profileInfo[1])}
                      </div>
                    )}
                    {profileInfo[2] && this.getInfoTitle(profileInfo[2]) && (
                      <div className='profile-info'>
                        <span className='info-title'>{this.getInfoTitle(profileInfo[2])}</span>
                        {this.getInfo(profileInfo[2])}
                      </div>
                    )}
                    {profileInfo[3] && this.getInfoTitle(profileInfo[3]) && (
                      <div className='profile-info'>
                        <span className='info-title'>{this.getInfoTitle(profileInfo[3])}</span>
                        {this.getInfo(profileInfo[3])}
                      </div>
                    )}
                    {profileInfo[4] && this.getInfoTitle(profileInfo[4]) && (
                      <div className='profile-info'>
                        <span className='info-title'>{this.getInfoTitle(profileInfo[4])}</span>
                        {this.getInfo(profileInfo[4])}
                      </div>
                    )}
                  </div>
                  {profileInfo.slice(1, profileInfo.length).filter(item => !!item).length > 2
                  && (
                    <div className='show-all' onClick={this.toggleInfo}>
                      <i className={store.showAllProfileInfo ? 'dplicon_direction_up' : 'dplicon_direction_down'} />
                      {store.showAllProfileInfo ? localeText('COMMON.BTN_HIDE') : localeText('COMMON.BTN_MORE')}
                    </div>
                  )}
                </div>
              </div>
            )
        }
        <div className='operation-list'>
          {userPermissionType !== USER_PERMISSION_TYPE.SUPER_ADMIN ? (
            <div
              className='switch-org actions'
              onClick={() => {
                store.setShowAdminInfo(false);
                showCompanySwitchModal();
              }}
            >
              <span>
                <i className='dpl20_swap' />
                {localeText('COMMON.BTN_SWITCH_OU')}
              </span>
            </div>
          ) : (
            ' '
          )}
          <div
            className='locale-switcher actions'
            onClick={() => {
              store.setShowAdminInfo(false);
              showLanguageSwitcherModal();
            }}
          >
            <span>
              <i className='dpl20_language' />
              {localeText('COMMON.BTN_LAN_SWITCH')}
            </span>
          </div>
          {fromPortal && (
            <div
              className='change-theme actions'
              onClick={() => {
                store.setShowAdminInfo(false);
                showChangeThemeModal();
              }}
            >
              <span>
                <i className='dpl20_theme' />
                {localeText('COMMON.BTN_CHANGE_THEME')}
              </span>
            </div>
          ) }
          {!user.domain && (
            <div
              className='change-password actions'
              onClick={() => {
                getPublicKey().then(() => {
                  this.props.securityStore.getPasswordRule(this.props.sessionStore.currentUser.id);
                  store.setShowAdminInfo(false);
                  showChangePasswordModal();
                });
              }}
            >
              <span>
                <i className='dpl20_lock' />
                {localeText('COMMON.BTN_CHANGE_CIPHER')}
              </span>
            </div>
          )}

          <div
            className='logout actions'
            onClick={() => {
              store.setShowAdminInfo(false);
              this.props.sessionStore.logout();
            }}
          >
            <span>
              <i className='dpl20_logout' />
              {localeText('COMMON.BTN_LOGOUT')}
            </span>
          </div>
        </div>
        <ProfileExpand />
      </div>
    </div>
  );

  // 展开个人信息时默认收起扩展区域
  initProfileExpand = (visible) => {
    if (!visible) {
      store.setShowAdminInfo(false);
      store.setShowExpandArea(false);
    }
  };

  render() {
    const {sessionStore, fromPortal} = this.props;
    return !sessionStore.currentUser ? (
      ''
    ) : (
      <div className='user-name'>
        <Dropdown overlay={this.getProfile(sessionStore, fromPortal)} trigger={['click']} overlayClassName='profile-dropdown' onVisibleChange={this.initProfileExpand}>
          <div className='sub'>
            {sessionStore.profileInfo
              ? <span className='user-info' title={sessionStore.currentUserInfo?.[sessionStore.profileInfo.filter(item => !!item)[0]]}>{sessionStore.currentUserInfo?.[sessionStore.profileInfo.filter(item => !!item)[0]]}</span>
              : <span className='user-info' title={sessionStore.currentUser.name}>{sessionStore.currentUser.name}</span>}
            <i className='dpl20_caret_down_s' />
          </div>
        </Dropdown>
        <LanguageSwitch />
        <ChangeTheme />
        <CompanySwitchList />
        <ChangeCipher />
      </div>
    );
  }
}

export default Profile;
